import React from 'react';
import { CollectionEntity, CollectionFetchType } from './model';
import { CollectionFilter } from './fetcher';

export const CollectionContext = React.createContext<CollectionContext>({
  setSelected() {},
  allFilters: [],
  filter: {
    type: 'all',
  },
  pairingModalOpen: false,
  setPairingModalOpen() {},
  setFilter() {},
});

export type CollectionContext = {
  selected?: CollectionEntity;
  setSelected(item: CollectionEntity): void;

  allFilters: CollectionFilter[];
  filter: CollectionFilter;
  setFilter(filter: CollectionFetchType): void;

  pairingModalOpen: boolean;
  setPairingModalOpen: (open: boolean) => void;
};

export const useCollectionContext = () => React.useContext(CollectionContext);
